import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { VaService } from '../../_services/va.service';
import { CommunityService } from '../../_services/community.service';

@Component({
  selector: 'app-sub-menu',
  templateUrl: './sub-menu.component.html',
  styleUrls: ['./sub-menu.component.scss']
})
export class SubMenuComponent implements OnInit, OnDestroy {

  subMenuItems:any;
  closeFlag = false;
  public shouldShow = true;
  public questionsCount: any;
  @ViewChild("myLabel", { static: false }) lab;

  updateCountSub: any;
  showSubMenuEventSub: any;
  badgeData = {};
  heading = '';

  constructor(public vaService:VaService,public communityService: CommunityService,) {

  }

  ngOnDestroy(): void {
    this.updateCountSub.unsubscribe();
    this.showSubMenuEventSub.unsubscribe();
  }

  ngOnInit() {
      this.showSubMenuEventSub = this.vaService.showSubMenuEvent.subscribe((data) => {

      this.subMenuItems = data;
      this.heading = this.subMenuItems[0].heading;
    })

      this.getQuestionsCount();
      this.communityService.updateCount.emit(true);




  }

 getQuestionsCount() {
    this.updateCountSub = this.communityService.updateCount.subscribe(result => {

      if (result) {
        this.communityService.getQuestionsCount(this.vaService.activeAgent._id.$oid).subscribe((result: any) => {

          this.questionsCount = result.count;
          this.badgeData = {...this.badgeData, ...result}
        });
      }
    });
  }




 showOrHideManually(item,event){

    this.subMenuItems.forEach(menuItem => {
    menuItem.isActive = false;
    })
   item.isActive = true;
   event.stopPropagation();
  this.vaService.subItemClickEvent.emit();
  }

}





